import {
  recordSyncIssue,
  SYNC_FAILED_MESSAGE,
  syncConflictMessage,
} from "../domain/syncIssue";

// The detail behind a "Sync issue" chip. Rendered only while the persisted
// record carries a non-retryable failure or a rejected write, so routine
// pending/retrying states stay quiet and the message survives a remount.
export default function SyncIssueNotice({ record }) {
  const issue = recordSyncIssue(record);
  if (!issue) return null;
  return (
    <p className="lz-workout-sync-issue" role="status">
      {issue.kind === "CONFLICT" ? syncConflictMessage(issue.code) : SYNC_FAILED_MESSAGE}
    </p>
  );
}
